import Icon from '@material-tailwind/react/Icon';

import Card from 'components/cards/Card';

export default function TransactionCategories({selected, setSelected}) {
    return (
        <div className="flex">
            <div className="w-1-3 md:w-full ml-3-custom md:ml-5" onClick={() => setSelected('all')}>
                <Card className={selected === "all" ? "bg-gray-100 shadow-2xl cursor-pointer" : "bg-green-500 shadow-2xl cursor-pointer"}>
                    <div className="flex items-center h-full">
                        <Icon name="star" size="3xl" />
                        <h3 className={`ml-4 ${"text-black"}`}>All</h3>
                    </div>
                </Card>
            </div>
            <div className="w-1-3 md:w-full ml-3-custom md:ml-5" onClick={() => setSelected('pending')}>
                <Card className={selected === "pending" ? "bg-gray-100 shadow-2xl cursor-pointer" : "bg-green-500 shadow-2xl cursor-pointer"}>
                    <div className="flex items-center h-full">
                        <Icon name="hourglass_empty" size="3xl" />
                        <h3 className={`ml-4 ${"text-black"}`}>Pending</h3>
                    </div>
                </Card>
            </div>
            <div className="w-1-3 md:w-full ml-3-custom md:ml-5" onClick={() => setSelected('success')}>
                <Card className={selected === "success" ? "bg-gray-100 shadow-2xl cursor-pointer" : "bg-green-500 shadow-2xl cursor-pointer"}>
                    <div className="flex items-center h-full">
                        <Icon name="check_circle" size="3xl" />
                        <h3 className={`ml-4 ${"text-black"}`}>Successfull</h3>
                    </div>
                </Card>
            </div>
        </div>
    )
}
